import React from "react";
import { Skeleton } from "./Skeleton";

// Enquanto a sessão é verificada: esqueleto da estrutura do backoffice (menu lateral, topo e conteúdo)
const Splash = () => (
    <div className="d-flex vh-100" aria-busy="true">
        <div className="bg-white p-3 d-none d-md-block" style={{ width: 240, borderRight: "1px solid #E5E7EB" }}>
            <Skeleton height={40} width="70%" className="mb-4" />
            {Array.from({ length: 7 }).map((_, i) => <Skeleton key={i} height={16} width={`${60 + (i % 3) * 12}%`} className="mb-3" />)}
        </div>
        <div className="flex-fill">
            <div className="bg-white d-flex align-items-center justify-content-between px-4" style={{ height: 64, borderBottom: "1px solid #E5E7EB" }}>
                <Skeleton height={16} width={180} />
                <Skeleton height={32} width={32} radius={16} />
            </div>
            <div className="p-4">
                <Skeleton height={22} width={200} className="mb-4" />
                <div className="d-flex gap-3 mb-4">
                    {Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} height={96} radius={8} style={{ flex: 1 }} />)}
                </div>
                <Skeleton height={300} radius={8} />
            </div>
        </div>
    </div>
);

export default Splash;
